import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { translateObject } from '@/libs/text'
import dayjs from 'dayjs'

type SalesType = {
  id: string
  salesDate: string
  salesSubjectName: string
  salesSubjectNameEn: string
  salesSubjectNameKo: string
  salesSubjectNameZh: string
  salesSubjectNameZhTw: string
  salesPrice: number
}

type ComponentProps = {
  reservationWithSales: Array<{
    reservationId: string
    assignRoomNumbers: string
    sales: SalesType[]
  }>
}

export const UsageDetailCard: React.FC<ComponentProps> = props => {
  const { t, i18n } = useTranslation()

  return (
    <div css={salesSubjectBlock} style={{ width: '60%' }}>
      <div className="block-title">{t('Usage details')}</div>
      <div className="reserve-and-sales-block">
        {props.reservationWithSales.map((r, i) => (
          <div key={r.reservationId}>
            <div className="reservation-row">
              <div>{`${t('Reserve')}${i + 1}`}</div>
              <div>{`${t('Guest room')} : ${r.assignRoomNumbers.split(',').join('、')}`}</div>
            </div>
            <div>
              {r.sales.map(s => (
                <div key={s.id} className="sales-row">
                  <div>
                    <div>{dayjs(s.salesDate).format('MM/DD')}</div>
                    <div>{translateObject(s, 'salesSubjectName', i18n.language)}</div>
                  </div>
                  <div>¥{s.salesPrice.toLocaleString()}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const salesSubjectBlock = css({
  backgroundColor: '#ffffff',
  borderRadius: 10,

  '.block-title': {
    padding: '10px 24px',
    fontWeight: 'bold',
    fontSize: 20,
    letterSpacing: 2.4,
    lineHeight: '19px',
  },
  '.reserve-and-sales-block': {
    overflow: 'auto',
    // sub block title (=39px)
    height: 'calc(100% - 39px)',
  },
  '.reservation-row': {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#F5F5F5',
    padding: '6px 24px',
    fontWeight: 'bold',
    fontSize: 16,
    letterSpacing: 1.8,
    lineHeight: '19px',
  },
  '.sales-row': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 24px',
    fontSize: 20,
    letterSpacing: 2.4,
    lineHeight: '19px',
    borderBottom: '1px solid #F2F2F2',
    'div:first-of-type': { display: 'flex', gap: 34 },
  },
})
